//#region Libraries
import styled from "styled-components";
//#endregion
//#region Styles
import { TDefContent, ActionsCell } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion

const MIN_WIDTH_CELL = "130px";
export const CustomCell = styled(TDefContent)`
    min-width: ${MIN_WIDTH_CELL};
    & h5 {
        color: var(--dark-2);
    }
`;
export const CustomActionsCell = styled(ActionsCell)`
    min-width: ${MIN_WIDTH_CELL};
`;